module.exports = __webpack_public_path__ + "static/media/workflow.c4c5bec6.png";